export default __webpack_public_path__ + "static/media/playstore_img.e8bf6156.png";